import axios, { AxiosError } from "axios";
import { env } from "@/config";
import { AssistedAffiliationDraftPayload } from "./types";

const assistedAffiliationDraftsEndpoint = "/v1/assisted-affiliation/draft";

/**
 * Crea la solicitud con lo que el usuario capturó.
 * @param payload - Ya armado por la pantalla, que es quien puede resolver los nombres de los
 * catálogos a partir de los identificadores que guarda el formulario.
 */
export const createDraftService = async (
  payload: AssistedAffiliationDraftPayload
) => {
  const response = await axios.post(
    `${env.MOCK_API_URL}${assistedAffiliationDraftsEndpoint}`,
    payload,
    {
      headers: { "Content-Type": "application/json" },
    }
  );

  return response.data;
};

const MAX_SERVER_MESSAGE_LENGTH = 200;

// El servidor puede responder una página HTML cuando la ruta no existe: mostrarla cruda no le dice nada al
// usuario, así que el body solo se acepta cuando parece una frase.
const isReadableMessage = (value: string) => {
  const trimmed = value.trim();
  return (
    trimmed.length > 0 &&
    trimmed.length <= MAX_SERVER_MESSAGE_LENGTH &&
    !trimmed.startsWith("<")
  );
};

export const getDraftErrorMessage = (
  error: unknown,
  fallback = "No se pudo crear el comercio."
) => {
  const axiosError = error as AxiosError<{ message?: string; error?: string } | string>;
  const responseData = axiosError.response?.data;

  if (typeof responseData === "string") {
    return isReadableMessage(responseData) ? responseData : fallback;
  }

  return responseData?.message || responseData?.error || fallback;
};
